import { connect } from 'react-redux';
import get from 'lodash/get';
import Scores from './ScoresExplainer';

import {
  selectGroupMatchesGrouped,
  selectBracketMatchesByRound,
  selectGroupWinners,
  selectBracketWinnersByRound,
  selectChampion,
} from '@selectors/scores';
import { selectUsesWc2026Bracket } from '@selectors/matches';

export const mapStateToProps = (state) => {
  if (!state.matches || state.matches.length === 0) {
    return { isReady: false };
  }

  return {
    isReady: true,
    pointsVersion: get(state, 'config.points.version', 1),
    groups: selectGroupMatchesGrouped(state),
    groupWinners: selectGroupWinners(state),
    brackets: selectBracketMatchesByRound(state),
    bracketWinners: selectBracketWinnersByRound(state),
    champion: selectChampion(state),
    total: get(state, 'scores.score', 0),
    usesWc2026Bracket: selectUsesWc2026Bracket(state),
  };
};

export default connect(mapStateToProps)(Scores);
